class window.PlayGame
    self = undefined
    ajaxLoader: '<i class="fa fa-spinner fa-pulse loader"></i>'
    ajaxSuccess: '<i class="fa fa-check success"></i>'
    ajaxError: '<i class="fa fa-times error"></i>'

    troopsPopup = undefined

    enum_turn_unstarted: 0
    enum_turn_card_turn_in: 1
    enum_turn_reinforcements: 2
    enum_turn_attack: 3
    enum_turn_send_after_attack: 4
    enum_turn_fortification: 5

    constructor: (game_id, info, @specialColorCss) ->
        self = this

        playerListIsEmpty = $('.player-list tr.player').length is 0
        @initTabs(info, playerListIsEmpty)
        @initGame(game_id, info, playerListIsEmpty)

    initTabs: (info, playerListIsEmpty) ->
        # Basic DOM elements.
        D12App.initializeTabs($('#left-panel-tabs'))
        D12App.initializeTabs($('#right-panel-tabs'))

        # Prepare the sounds
        @alertTurn = $('#sound_turn-alert').get(0)
        @alertTime = $('#sound_time-alert').get(0)

        # Territory select.
        @initializeTerritorySelect()

        # Options tab.
        if $('#options-tab')?
            @initializeOptions()

        # Support tab.
        if $('#support-tab')?
            @initializeSupport()

        # Report tab.
        if $('#report-tab')?
            @initializeReport()

        # Debug tab.
        if $('#debug-tab')?
            @initializeDebug()

        # Join game tab.
        if $('#join-game')?
            @initializeJoinGame((not info? or info.status is 3) and playerListIsEmpty)

        # Preset chat tab.
        if $('#preset-chat')?
            @initializePresetChat()

        # Game log.
        if $('#game-log')?
            @initializeGameLog()

        # Notes tab.
        if $('#player-notes')?
            @initializeNotes()

    initGame: (game_id, info, playerListIsEmpty) ->
        @gameID = game_id

        # If the game is ended, only initialise the minimum required to run the page.
        if not info? or info.status is 3
            if playerListIsEmpty
                @showAllPlayersLeftModal()
            return

        @gameState = info.game_state
        @cards = info.cards
        @cardBonus = info.cardBonus
        @players = info.players
        @turns = info.turns
        @status = info.status
        @me = info.me
        @lastUpdate = info.now
        @fortification = info.fortification
        @showBetaConfirm = info.show_beta_confirm
        @showTroopPopups = info.show_troop_popups
        @useExperimentalGameUI = info.use_experimental_game_ui
        @failedUpdates = 0

        @attacksQueued = 0
        @attackRequestActive = false

        if @status is 1
            @initializePreGame(info.autokick_at)
        else if @me?
            # If it's our turn, initialise it.
            @myTurn = @turns.filter((turn) => turn.user_id is @me.user_id)[0]
            if @myTurn
                @initializeTurn()

        # Finally, initialise the update loop.
        # Store it in a variable so we can pause/resume/stop it.
        @timeTillNextUpdate = 8
        @updateLoop = setInterval(@update, 1000)

    #
    # Update loop
    #
    # NB: this method uses a fat arrow, this makes a new version of the
    #     "update" function for every instance, but this makes sense in
    #     the case of this function. See coffeescript documentation for
    #     more information on the fat arrow,
    update: (force = false) =>
        # Pick a turn, any turn.
        turn = @turns[0]

        if turn?
            @updateTime(moment.utc(turn.expires_at, 'YYYY-MM-DD HH:mm:ss Z'), '#turn-timer', @myTurn?)

        if @autokickAt
            @updateTime(@autokickAt, '#autokick-timer', true, 'm:ss')

        if @timeTillNextUpdate?
            @timeTillNextUpdate -= 1
            if @timeTillNextUpdate <= 0 and activity.wasLastActivityWithin(activity.longActivityThreshold)
                @ajax('update-state', { }, (result) =>
                    @failedUpdates = 0
                    if result.state?
                        @runUpdates(result)
                    if @autokickAt? and @status is 1 and not $('#autokick-timer')?
                        @initializePreGame(@autokickAt)
                    @updateTurn(result.turn, force)
                , (jqXHR, textStatus, errorThrown) ->
                    self.reportAjaxError(jqXHR, textStatus, errorThrown)
                    self.failedUpdates += 1

                    if self.failedUpdates >= 5
                        self.cleanUpAfterTurn()
                        self.showModal('This game has been suspended due to server errors.')
                        clearInterval(self.updateLoop)
                )
                @timeTillNextUpdate = if activity.wasLastActivityWithin(activity.activityThreshold) then 8 else 16
            else if not activity.wasLastActivityWithin(activity.longActivityThreshold)
                @showActivityMonitorModal()

        $('#refresh-next')?.html(@timeTillNextUpdate)
        $('#refresh-delay')?.html(if activity.wasLastActivityWithin(activity.activityThreshold) then 0 else 8)

    updateTime: (expires, dom, playSound, format) ->
        # Calculate the amount of time left.
        now = moment.utc()

        if (now >= expires)
            timeLeft = moment.utc(0)
        else
            timeLeft = moment.utc(expires - now)

        if format?
            $(dom).html(timeLeft.format(format))
        else
            hours = expires.diff(now, 'hours')
            if hours >= 24
                $(dom).html(hours + timeLeft.format(':mm:ss'))
            else
                $(dom).html(timeLeft.format('HH:mm:ss'))

        # Play sound alert if 15 seconds left
        if (playSound and $('#check_alert-time').prop('checked'))
            seconds = expires.diff(now, 'seconds')
            if seconds is 15
                @alertTime.play()

        # If time left is 0, do an immediate update.
        if timeLeft <= 0
            @timeTillNextUpdate = 0

    #
    # Applying changes
    #
    runUpdates: (result) ->
        # Don't update old results
        if (result.now < @lastUpdate)
            return

        @lastUpdate = result.now
        @me = result.me

        # Status changes
        if @status is 1 and result.status is 2
            @onGameStart()
        if @status is 2 and result.status is 3
            @onGameEnd(result.winner)
        @status = result.status

        # if not @me
        #     @cleanUpAfterTurn()

        if result.players?
            @updatePlayerlist(result.players)
            if result.status is 3 and result.players.length is 0
                @showAllPlayersLeftModal()

        if (result.me?)
            # Update add time left
            $('.add-time-left').html(result.me.add_time_left)
            $('.add-time-left').parent().prop('disabled', result.me.add_time_left is 0 or result.status isnt 2)

            # Update resign
            $('#resign-confirm').prop('disabled', result.status isnt 2)
            if result.status isnt 2
                # Force resign button to disabled
                $('#resign-button').prop('disabled', true)

            # Initialise team chat maybe?
            if result.status is 2 and teamChat is null # teamchat exists but is not initialised
                teamChat = new Chat('#team-chat .chat-wrapper', me.team, @gameID)
                $('#team-chat-tab-link').parent().css('display', '')

            if result.status is 2 and @me? and not @tabsInitialized
                $('#report-tab-link').parent().css('display', '')
                $('#player-notes-tab-link').parent().css('display', '')
                @tabsInitialized = true

        # # Every time some turns have ended, check if I need a notification and cleanup.
        # if @myTurn and not self.turns.every((elmt) ->
        #     result.turns.some((elmt2) ->
        #         elmt.user_id is elmt2.user_id and elmt.round is elmt2.round and elmt.user_id is self.me.user_id))
        # # {
        #     @cleanUpAfterTurn()
        #     @showNotificationBanner(@me.color, 'Turn finished.')
        # # }

        # Every time there are new turns (but it's not the end of my turn), show the banner and play the turn sound.
        if not @myTurn and not result.turns.every((elmt) -> self.turns.some((elmt2) -> elmt.user_id is elmt2.user_id))
            if result.turns.length is 1 # Don't deal with same time banners
                t = result.turns[0]
                p = @findPlayerByUserID(@players, t.user_id)
                if (not @me?) or p.user_id isnt @me.user_id
                    text = 'Turn: ' + p.username
                    if @me
                        text = text + ', please wait.'
                    if self.turns.length is 0
                        text = 'Game started. ' + text

                    @showNotificationBanner(p.color, text)

            if $('#check_alert-turn').prop('checked') # Check alert setting.
                @alertTurn.play()

        @turns = result.turns
        @cards = result.cards
        @cardBonus = result.cardBonus

        if result.attacker_rolls? and @status isnt 3
            @showDice(result.attacker_rolls, @me.color, result.defender_rolls, result.defender_color)

        if result.cards?
            $('#cards').html(result.cards.map((card) -> card.formattedHtml).join(', '))
            if (result.cardBonus > 0)
                $('#next-bonus').html(result.cardBonus)

        for i, p of result.state.players
            @updatePlayer(i, @gameState, @turns.filter((turn) => turn.user_id is @players[i].user_id)[0]?, p)

        for i, t of result.state.territories
            @updateTerritory(i, @gameState, @players, t)

        for i, e of result.log
            @addLogEntry(i, e)

        if result.target?
            @initializeTargets(result.target)

    onGameStart: () ->
        @cleanUpAfterTurn()

        # Completely reset playerlist, because the order will change
        @players = {}
        $(".player-list tr").remove()

    onGameEnd: (winner) ->
        @cleanUpAfterTurn()

        # Stop interval loop
        $('#turn-timer').html('88:88:88')
        clearInterval(@updateLoop)

        # Show winner
        if (winner) # There is a winner, should be sent with the request
            # Show win status in player list.
            for i, p of @players
                if p.team is winner.team
                    row = $("#playerrow-#{p.player_id}")
                    status = row.find('.status-icon')
                    status.addClass('winner')

            # Show banner.
            if (@me? and winner.team is @me.team)
                @showNotificationBanner(@me.color, 'Congratulations, you have won!')
            else
                text = 'Game has ended. ' + noun('Winner', 'Winners', winner.names is 1) + ': '
                text += winner.names.join(', ')
                text += '.'

                @showNotificationBanner(winner.color, text)
        else # There is no winner.
            @showNotificationBanner((if @me? then @me.color else 0), 'Game has ended.')

    findPlayerByUserID: (players, user_id) ->
        for i, p of players
            if p.user_id is user_id
                return p
        return undefined

    updatePlayerlist: (players) ->
        # Compare our current player list to the new player list.
        # This code tries to be smart and not remove all the rows all the time

        # We don't try to be smart about the side boxes or css selectors though and just remove all
        $('#side-boxes div.side-box-player').remove()
        $('.color-select div').css('display', 'block')

        # 1. Remove all players that are no longer there.
        for i, p of @players
            if (typeof players is 'array' and not players.some((p2) -> p.user_id is p2.user_id)) or
                    (typeof players is 'object' and not players[p.player_id]?)
                $(".player-list tr[data-user=#{p.user_id}]").remove()
                @updateChatColor(p.user_id, 0)

        # 2. Add all the new players.
        for i, p of players
            # Always add all side boxes and enable all color selectors
            $('#side-boxes').append(p.sideBoxHtml)
            $(".color-select .tc-#{p.color}").css('display', 'none')
            if (typeof @players is 'array' and not @players.some((p2) -> p.user_id is p2.user_id)) or
                    (typeof @players is 'object' and not @players[p.player_id]?)
                $('.player-list > tbody').append(p.rowHtml)
                @updateChatColor(p.user_id, p.color)

        # Remove the token cost warning if there 2 players left (or less)
        if @status is 2 and @countActivePlayers(players) <= 2
            $('#resign-cost').html('0')

        @players = players

    countActivePlayers: (players) ->
        result = 0
        for i, p of players
            if (p.alive and not p.resigned)
                result++
        return result

    updateChatColor: (userID, colour) ->
        $(".chat-messages li[data-user=#{userID}] a.chat-name").each(() ->
            for key, val of playercolors
                $(this).removeClass("chat-#{key}")
            $(this).addClass("chat-#{colour}")
            if self.specialColorCss[userID]?
                if colour is 0
                    $(this).attr('style', self.specialColorCss[userID])
                else
                    $(this).removeAttr('style')
        )

    updateTurn: (turn, force = false) ->
        if force or not turn? or not @myTurn? or turn.step isnt @myTurn.step or turn.round isnt @myTurn.round
            if @myTurn? and not turn?
                @cleanUpAfterTurn()
                if @status isnt 3
                    navBarUpdater.updateImmediately()
                    @showNotificationBanner(@me.color, 'Turn finished.')

            @myTurn = turn

            if @myTurn?
                @initializeTurn()

    updatePlayer: (playerID, gameState, activeTurn, newPlayerState = null) ->
        if newPlayerState?
            gameState.players[playerID] = newPlayerState

        playerState = gameState.players[playerID]

        if not playerState?
            return

        row = $("#playerrow-#{playerID}")
        row.find('.numCards').html(playerState.cards)
        row.children('.territories').html(playerState.territories)
        row.children('.troops').html(playerState.troops)
        row.children('.reinforcements').html(playerState.reinforcements)

        status = row.children('.status-icon')

        status.removeClass('turn dead resigned')
        if (@players[playerID].resigned)
            status.addClass('resigned')
        else if (not playerState.alive)
            status.addClass('dead')
        else if (activeTurn)
            status.addClass('turn')

    updateTerritory: (territoryID, gameState, players, newTerritoryState = null) ->
        if newTerritoryState?
            oldTerritoryState = gameState.territories[territoryID]
            gameState.territories[territoryID] = newTerritoryState

        currTerritoryState = gameState.territories[territoryID]

        link = $("#territory-#{territoryID}")

        # Check if the colour has changed at all.
        if not oldTerritoryState? or oldTerritoryState.player_id isnt currTerritoryState.player_id
            parent = link.parent()
            parent.removeClass((index, css) ->
                (css.match(/(^|\s)tc-\S+/g) or []).join(' ')
            )
            parent.removeClass('capital')

            playerID = currTerritoryState.player_id

            # Territory colour
            if not playerID?
                parent.addClass('tc-fog')
            else
                color = if playerID > 0 then players[playerID].color else 0
                parent.addClass("tc-#{color}")

            if currTerritoryState.is_capital
                parent.addClass('capital')

            # Colour blind tooltip
            tooltip = parent.find('.tt-inner')
            if (tooltip?)
                if not playerID?
                    tooltip.html('Unknown')
                else
                    tooltip.html(playercolors[color].ucfirst())

                    if playerID? and playerID > 0 and players[playerID].teamString?
                        letter = players[playerID].teamString
                        tooltip.append(" <span class=\"tt-team\">#{letter}</span>")

        # Check if the colour OR number of troops has changed.
        if not oldTerritoryState? or oldTerritoryState.player_id isnt currTerritoryState.player_id or
                oldTerritoryState.troops isnt currTerritoryState.troops
            troops = currTerritoryState.troops
            link.html(if troops > 0 then troops else '')

            # Troop popup
            if oldTerritoryState? and @showTroopPopups
                if oldTerritoryState.player_id isnt newTerritoryState.player_id
                    queue(() => @spawnTroopPopup(territoryID, oldTerritoryState.troops))
                else
                    queue(() => @spawnTroopPopup(territoryID, newTerritoryState.troops - oldTerritoryState.troops))

    addLogEntry: (id, string) ->
        # Remove possible old entry
        $("#logentry-#{id}").remove()
        # Add new entry in front
        $('#game-log-list').prepend(string)

    #
    # Ajax helpers
    #
    getAjaxURL: (operation) -> "#{baseurl}/game/#{@gameID}/play/#{operation}"

    ajax: (operation, data, onSuccess, onError = undefined) ->
        data._token = csrftoken
        data.last_update = @lastUpdate

        return $.ajax({
            url: @getAjaxURL(operation)
            method: 'POST'
            data: data
            success: onSuccess
            error: if onError? then onError else @reportAjaxError
        })

    reportAjaxError: (jqXHR, textStatus, errorThrown) ->
        errorMessage = textStatus
        if (jqXHR.status >= 400 and jqXHR.status < 500)
            if (jqXHR.responseJSON?.message?)
                errorMessage = jqXHR.responseJSON.message
            else
                errorMessage = jqXHR.responseText
        messageDisplay.error("status: #{errorThrown}, error: #{errorMessage}")

    reportError: (error) ->
        if error?
            messageDisplay.error("<strong>error:</strong> " + error)

    #
    # Initialisation
    #
    initializeTerritorySelect: () ->
        $('.js_territory').click(() ->
            if not self.myTurn? or self.myTurn.step is 4
                return false

            terrID = $(this).data('territory')

            switch self.myTurn.step
                when 2
                    # Choose a territory to reinforce
                    if (self.isTerritoryFriendly(terrID))
                        self.selectTerritory(terrID, $(this))

                when 3
                    # Choose a territory to attack from
                    if (self.isTerritoryMine(terrID) and
                            self.gameState.territories[terrID].troops > 1 and
                            not self.isTerritorySurrounded(terrID))
                        self.selectTerritory(terrID, $(this))

                    # Choose a territory to attack
                    else if (self.selectedTerritory? and
                            not self.isTerritoryMine(terrID) and
                            self.areTerritoriesAdjacent(self.selectedTerritory, terrID))
                        self.targetTerritory(terrID, $(this))

                when 5
                    # Choose a territory to fortify from
                    if (self.isTerritoryMine(terrID) and
                            self.gameState.territories[terrID].troops > 1 and
                            not self.isTerritoryIsolated(terrID) and
                            (not self.selectedTerritory? or # Don't have a territory selected yet, or
                                # can't fortify to this territory, so instead we'll reset the selection to this one
                                not self.checkFortificationConnectivity(self.selectedTerritory, terrID)))
                        self.selectTerritory(terrID, $(this))

                    # Choose a territory to fortify
                    else if (self.selectedTerritory? and
                            self.isTerritoryFriendly(terrID) and
                            self.checkFortificationConnectivity(self.selectedTerritory, terrID))
                        self.targetTerritory(terrID, $(this))

            return false # suppress default event
        )

    initializeOptions: () ->
        # Add time options.
        $('#add-time-button').click(() =>
            $('#add-time-button').parent().append(@ajaxLoader)

            @ajax('add-time', {}, (result) =>
                if (result.success)
                    @runUpdates(result)
                    @updateTurn(result.turn)
                else
                    @reportError(result.error)

                $('#add-time-button').parent().find('.loader').remove()
            )
        )

        $('#enable-absence-button').click(() =>
            $('#enable-absence-button').parent().append(@ajaxLoader)

            @ajax('enable-absence', {}, (result) =>
                if (result.success)
                    @runUpdates(result)
                    @updateTurn(result.turn)
                else
                    @reportError(result.error)

                $('#enable-absence-button').parent().find('.loader').remove()
            )
        )

        # Resign.
        $('#resign-confirm').click(() ->
            $('#resign-button').prop('disabled', not $(this).prop('checked'))
        )

        $('#resign-button').click(() =>
            $('#resign-button').prop('disabled', true)
            @ajax('resign', {}, (result) =>
                if result.success is true
                    @runUpdates(result)
                    @updateTurn(result.turn, true)
                else
                    @reportError(result.error)
            )
        )

        # Play icons.
        $('#play-turn-alert').click(() =>
            @alertTurn.play()
        )
        $('#play-time-alert').click(() =>
            @alertTime.play()
        )

        # Set checkbox values.
        if readCookie('alert-turn-mute') is 'mute'
            $('#check_alert-turn').prop('checked', false)
        if readCookie('alert-time-mute') is 'mute'
            $('#check_alert-time').prop('checked', false)

        # Toggle checkbox values in cookies.
        $('#check_alert-turn').click(() ->
            eraseCookie('alert-turn-mute')
            if not $(this).prop('checked')
                createCookie('alert-turn-mute', 'mute', '5y')
        )
        $('#check_alert-time').click(() ->
            eraseCookie('alert-time-mute')
            if not $(this).prop('checked')
                createCookie('alert-time-mute', 'mute', '5y')
        )

    initializeSupport: () ->
        # Ask for help
        $('#ask-support-form').submit(() =>
            $(this).find('button').prop('disabled', true)

            self.ajax('ask-support', {
                type: $('#ask-support-type').val()
            }, (result) ->
                if result.success
                    messageDisplay.success('staff notified')
                else
                    self.reportError(result.error)

                $('#ask-support-form button').prop('disabled', false)
            )

            return false
        )

    initializeReport: () ->
        # Reports
        $('#report-player-form').submit(() ->
            $(this).find('button').prop('disabled', true)

            self.ajax('send-report', {
                user_id: $('#reported-player').val()
                type: $('#report-type').val()
            }, (result) ->
                if result.success
                    body = $('#reports tbody')
                    body.prepend(result.html)

                    children = body.children('tr').length

                    # Limit length of table.
                    if children is 5
                        body.find('tr:nth-child(5)').remove()
                        body.append('<tr>' +
                            '<td class="right" colspan="3">and <span id="reports-more">1</span> more...</td>' +
                        '</tr>')
                    else if children is 6
                        body.find('tr:nth-child(5)').remove()
                        $('#reports-more').html(parseInt($('#reports-more').html(), 10) + 1)
                else
                    @reportError(result.error)

                $('#report-player-form button').prop('disabled', false)
            )

            return false
        )

        $('#update-reports').click(() =>
            @ajax('get-reports', { }, (result) ->
                body = $('#reports tbody')
                body.html('')
                for i, r of result
                    if parseInt(i, 10) < 4
                        body.append(r)
                    else if parseInt(i, 10) is 4
                        body.append('<tr><td class="right" colspan="3">and <span id="reports-more">' +
                                (Object.keys(result).length - 4) + '</span> more...</td></tr>')
            )
        )

        $('#report-type').change(() ->
            selected = $(this).find(':selected')
            $('#report-type-tt .tt-inner').html(selected.data('tooltipText'))
        )
        # Initial update
        $('#report-type').change()

    initializeDebug: () ->
        $('#refresh-now').click(() =>
            @ajax('update-state', { }, (result) =>
                @runUpdates(result)
                @updateTurn(result.turn)
            )
        )
        $('#refresh-toggle').click(() ->
            if self.timeTillNextUpdate?
                self.timeTillNextUpdate = null
                $(this).html('Toggle (off)')
            else
                self.timeTillNextUpdate = 0
                $(this).html('Toggle (on)')
        )

        $('#chat-refresh-now').click(() ->
            publicChat.update()
            navBarUpdater.updateImmediately()
            if teamChat?
                teamChat.update()
        )
        $('#chat-refresh-toggle').click(() ->
            if activity.isPausedForDebugging
                activity.resumeForDebugging()
                publicChat.resetInterval()
                if teamChat?
                    teamChat.resetInterval()
                $(this).html('Toggle (on)')
            else
                activity.pauseForDebugging()
                clearInterval(publicChat.updateLoop)
                if teamChat?
                    clearInterval(teamChat.updateLoop)
                $(this).html('Toggle (off)')
        )

    initializeJoinGame: (ignoreSubmit = false) ->
        @initializeColorSelect()

        $('#right-panel-tabs .tab-link').click(() ->
            if self.status is 1 and not self.me
                if $(this).attr('href') is '#join-game'
                    self.removeModal() # Remove join game modal
                else
                    self.showJoinModal() # Show join game modal
        )

        if not ignoreSubmit
            $('.join-game-submit').click(() ->
                $(this).attr('disabled', 'disabled')

                if self.me?
                    return false

                if not self.showBetaConfirm or
                        confirm('This game contains beta settings. Are you sure you want to join?' +
                            "\n\n" + '(This alert can be disabled in your game settings.)')

                    # Retrieve color
                    color = $('.color-select .radio[name="color"]:checked').val()

                    $('.join-game-status').html(self.ajaxLoader)

                    data = {
                        color: color
                    }

                    if ($('.join-pw'))
                        data['password'] = $('.join-pw').val()

                    self.ajax('join-game', data, (result) =>
                        if (result.success)
                            self.me = result.me
                            $('.join-game-status').html(self.ajaxSuccess)

                            # Update player list.
                            if result.players?
                                self.updatePlayerlist(result.players)

                            # If game has started, run immediate gamestate update.
                            if result.started
                                self.timeTillNextUpdate = 0
                            else
                                self.initializePreGame(result.autokick_at)

                            # Remove the selected from the selected element.
                            $('.color-select .selected').removeClass('selected')
                            # Remove the password
                            $('.join-pw').replaceWith('<span>No password needed because you have joined before.</span>')
                            # Switch to the chat tab.
                            $('#game-chat-tab-link').click()
                        else
                            $('.join-game-status').html(self.ajaxError + ' ' + result.error)
                            $(this).removeAttr('disabled')
                    , (jqXHR, textStatus, errorThrown) =>
                        $('.join-game-status').html(self.ajaxError + ' ' + errorThrown)
                        $(this).removeAttr('disabled')
                    )
                else
                    $(this).removeAttr('disabled')

                return false
            )

    initializeColorSelect: () ->
        $('.color-select a').click(() ->
            if self.me?
                return false

            colorID = $(this).data('color')
            gameID = $(this).data('gameId')

            $("#join-game-color-select-#{gameID} .radio[data-color=#{colorID}]").click()

            $("#join-game-color-select-#{gameID} div").removeClass('selected')
            $(this).parent().addClass('selected')

            $("#join-game-color-select-#{gameID} .join-game-submit").removeAttr('disabled')
            $("#join-game-color-select-#{gameID} .join-game-submit").removeClass('disabled')

            return false
        )

    initializePresetChat: () ->
        # Change the target of the chat (public or team)
        $('#preset-chat-target a').click(() ->
            if $(this).is('.public')
                $(this).html('To team <i class="fa fa-comment-o"></i>')
                $(this).removeClass('public')
                $(this).addClass('team')
            else
                $(this).html('To all <i class="fa fa-comment-o"></i>')
                $(this).removeClass('team')
                $(this).addClass('public')
            return false
        )
        # Initialise the target link
        $('#preset-chat-target a').click()
        # When clicking on a preset chat line, send chat and go back to the categories menu
        $('.preset-chat-line').click(() ->
            if $('#preset-chat-target a.team').length > 0
                teamChat.sendChat($(this).html())
            else
                publicChat.sendChat($(this).html())
            $('.preset-chat-menu').hide()
            $('#preset-chat-menu').show()
            return false
        )

    initializeGameLog: () ->
        # Load full log
        $('#load-log').click(() ->
            $(this).parent().html(self.ajaxLoader)

            # Get the first log entry we actually have.\
            firstDom = $('#game-log-list').find('[data-entry-id]:last')
            first = firstDom.data('entryId')

            self.ajax('load-full-log', { 'before': first }, (result) ->
                list = $('#game-log-list')
                for i, e of result.log
                    #list.append(e)
                    firstDom.after(e)
                list.find('.more').remove()
            )
        )

    initializeNotes: () ->
        # Save notes
        $('#notes-btn-save').click(() =>
            $('#notes-status-save').html(@ajaxLoader)
            @ajax('save-notes', { 'body': $('#notes').val() }, (result) =>
                if (result.success)
                    $('#notes-status-save').html(@ajaxSuccess)
                else
                    $('#notes-status-save').html(@ajaxError + ' ' + result.error)
            , (jqXHR, textStatus, errorThrown) =>
                $('#notes-status-save').html(@ajaxError + ' ' + errorThrown)
            )

            return false
        )

        # Refresh notes on reopening tab
        $('#player-notes-tab-link').click(() =>
            # Disable notes and button
            $('#notes,#notes-btn-save').attr('disabled', 'disabled')
            $('#notes-status-save').html(@ajaxLoader)
            @ajax('get-notes', { }, (result) ->
                $('#notes').val(result.notes.body)
                $('#notes,#notes-btn-save').removeAttr('disabled')
                $('#notes-status-save').html('')
            )
        )

    initializeTargets: (targetHtml) ->
        $('#gametype-info-string').html(targetHtml)

        $('#switch-target-link').unbind('click')

        $('#switch-target-link').click(() =>
            $('#gametype-info-string').append(@ajaxLoader)

            @ajax('switch-targets', {}, (result) =>
                if (result.success)
                    @initializeTargets(result.targetHtml)
                else
                    @reportError(result.error)

                $('#gametype-info-string').parent().find('.loader').remove()
            )

            return false
        )

    #
    # Before the game has started
    #
    initializePreGame: (autokick_at) ->
        if @me? # I joined, show invite/leave game
            @autokickAt = if autokick_at? then moment.utc(autokick_at, 'YYYY-MM-DD HH:mm:ss Z') else null

            content = 'Waiting for players to join.
                <button onclick="playGame.leaveGame()">Leave game</button>
                <hr>
                <a target="_blank" href="' + baseurl + '/userlist?online=1&sort=last_active&dir=desc&invite=' +
                    @gameID + '">Invite</a> users:
                <span style="white-space: nowrap;">
                    <input type="text" data-typeahead="remote:api/user/names?online=1,api/user/names?q=%QUERY"
                        placeholder"Search user" id="invite-user">
                    <button onclick="playGame.inviteUser()">Send invite</button>
                </span>'

            if autokick_at?
                content += '<hr>
                    You will automatically leave the game in <span id="autokick-timer"></span>
                    <button onclick="playGame.stillHere()">Still here</button>'

            @showModal(content)
            $('#invite-user').initTypeahead()

            if autokick_at?
                @updateTime(@autokickAt, '#autokick-timer', true, 'm:ss')
        else    # Not joined yet, show join game modal
            @showJoinModal()

    goToJoinTab: () ->
        $('#join-game-tab-link').click()
        $('html, body').animate({
            scrollTop: $("#join-game").offset().top
        }, 200)
        @removeModal()

    leaveGame: () ->
        if not @me?
            return false

        @makeModelLoading()
        @ajax('leave-game', {}, (result) =>
            if result.success
                @me = null

                # Update player list.
                if result.players? and result.players.length
                    @initializePreGame()
                    @updatePlayerlist(result.players)

                    # If we joined without refreshing, the status will still be there.
                    $('.join-game-status').html('')
                else # No players left, game ended
                    @cleanUpAfterTurn()
                    @showNotificationBanner(0, 'Game ended.')
                    # TODO: hide join game tab?
            else
                @reportError(result.error)
        )

        return false

    inviteUser: () ->
        if not @me?
            return false

        @ajax('send-invite', {
            username: $('#invite-user').val()
        }, (result) =>
            if result.success
                $(this).prop('disabled', false)
                $('#invite-user').val('')
                messageDisplay.success('User invited.')
            else
                @reportError(result.error)
        )

        return false

    stillHere: () ->
        if not @me?
            return false

        @ajax('still-here', {}, (result) =>
            if result.success
                @initializePreGame(result.autokick_at)
            else
                @reportError(result.error)
        )

    #
    # Turn
    #
    initializeTurn: () ->
        @clearSelections()

        if not @myTurn.step?
            @myTurn.step = @enum_turn_unstarted

        switch @myTurn.step
            when @enum_turn_unstarted
                # In same time games there may be leftovers from the previous turn.
                @cleanUpAfterTurn()
                @showModal('It is your turn.
                    <button onclick="playGame.beginTurn()">Begin turn</button>')
            when @enum_turn_card_turn_in
                @showCardModal()
            when @enum_turn_reinforcements
                numReinforcements = @gameState.players[@me.player_id].pending_reinforcements
                @showStepBanner(@me.color, "You have #{numReinforcements} reinforcements.
                    Choose a territory to reinforce.",
                    '', '',
                    '<button onclick="playGame.undo(' + @enum_turn_reinforcements +
                    ')">&laquo; Back to card turn in</button>')
            when @enum_turn_attack
                @showStepBanner(@me.color, 'Choose a territory to attack from.', '',
                    '<button onclick="playGame.advancePhase(' + @enum_turn_attack + ')">End phase</button>')

                # Close the troops popup if it is still there.
                # In same time games, we may be pushed back to this state if a territory was taken while we were still
                # moving troops.
                if (@troopsPopup?)
                    @troopsPopup.close()
                    @troopsPopup = undefined
            when @enum_turn_send_after_attack
                myState = @gameState.players[@me.player_id]
                select = myState.last_conquer.from
                target = myState.last_conquer.to

                @selectTerritory(select, $("#territory-#{select}"))
                @targetTerritory(target, $("#territory-#{target}"))

                if (not (@troopsPopup?))
                    @showMoveTroopsUI(@selectedTerritory, @targetedTerritory)
            when @enum_turn_fortification
                @showStepBanner(@me.color, 'Choose a territory to fortify from.', '',
                    '<button onclick="playGame.endTurn()">End turn</button>',
                    '<button onclick="playGame.undo(' + @enum_turn_fortification +
                    ')">&laquo; Back to attack phase</button>')

    cleanUpAfterTurn: () ->
        @removeModal()
        @removeStepBanner()
        @removeDice()
        @clearSelections()
        if (@troopsPopup?)
            @troopsPopup.close()
            @troopsPopup = undefined

    #
    # UI
    #
    showModal: (content) ->
        # Remove the old modal
        @removeModal()

        container = $('#modal-container')
        container.append('<div id="modal" class="modal">' + content + '</div>')
        modal = $('#modal')
        modal.offset({
            top: 0.3 * ($(window).height() - modal.height()) + $(window).scrollTop()
            left: 0.5 * ($(window).width() - modal.width()) + $(window).scrollLeft()
        })

        # Modal dragging
        modal.mousedown((e) ->
            window.drag = {}
            drag.initialX = e.pageX
            drag.initialY = e.pageY
            drag.initialOffset = $(this).offset()
            drag.elem = this

            onMouseUp = () ->
                $('body')
                    .off('mouseup', onMouseUp)
                    .off('mousemove', onMouseMove)
                    .css('cursor', 'auto')

            onMouseMove = (e) ->
                $(drag.elem).offset({
                    left: drag.initialOffset.left + e.pageX - drag.initialX
                    top: drag.initialOffset.top + e.pageY - drag.initialY
                })
                return false # Prevents selection

            $('body')
                .on('mouseup', onMouseUp)
                .on('mousemove', onMouseMove)
                .css('cursor', 'move')
        )

        modal.find('button, input').mousedown((e) -> e.stopImmediatePropagation())

    showJoinModal: () ->
        @showModal('<button onclick="playGame.goToJoinTab()">Join game</button>')

    showAllPlayersLeftModal: () ->
        @showModal('This game has ended because all players left ' +
            '(<a href="#" onclick="playGame.goToJoinTab(); return false;">re-open</a>).')

    showActivityMonitorModal: () ->
        minutes = activity.longActivityThreshold.asMinutes()
        @showModal("Auto refresh has been disabled due to inactivity for more than #{minutes} minutes. " +
            '<button type="button" onclick="playGame.reenableAfterInactivity(); return false;">Re-enable</button>')

    reenableAfterInactivity: () ->
        @removeModal()
        @timeTillNextUpdate = 0
        @update(true)

    showCardModal: () ->
        content = 'Please select the cards you would like to turn in:' +
            '<form onsubmit="playGame.turnInCards(); return false;">' +
            '<ul class="card-select">'

        for i, c of @cards
            cardData = (c.territory_id << 2) + c.deck_no
            content += '<li><label><input type="checkbox" onclick="playGame.validateCards();"' +
                'data-card-checkbox="' + cardData + '"> ' + c.formattedHtml + '</label></li>'

        content += '</ul>' +
            '<button type="submit" disabled="disabled" id="card-turn-in-submit">Turn in cards</button>'

        if @cards.length < 5
            content += ' <button type="button" onclick="playGame.advancePhase(' + @enum_turn_card_turn_in +
            '); return false;">Skip turn in</button>'

        content += '</form>'

        @showModal(content)

    makeModelLoading: () ->
        # DOM elements
        modal = $('#modal')
        buttons = $('#modal > button')

        # Disable button
        buttons.prop('disabled', true)

        # Add AJAX loader
        $(@ajaxLoader).insertAfter(buttons.first())

    removeModal: () ->
        $('#modal')?.remove()

    showNotificationBanner: (color, content) ->
        # Remove the old banner
        @removeNotificationBanner()

        container = $('#modal-container')
        container.append(
            '<div id="notification-banner" class="notification-banner banner-' + color + '">
                <div class="container">
                    ' + content + '
                </div>
            </div>')

        banner = $('#notification-banner')
        banner.offset({
            top: 0.5 * ($(window).height() - banner.height()) + $(window).scrollTop()
        })

        banner.delay(1500).fadeOut('fast')

    removeNotificationBanner: () ->
        $('#notification-banner')?.remove()

    showStepBanner: (color, content, actions = '', next = '', back = '') ->
        # Remove the old banner
        @removeStepBanner()

        container = $('#modal-container')
        container.append(
            '<div id="step-banner" class="step-banner banner-' + color + '">
                <div class="container">
                    <div id="turn-progress">
                        <ul>
                            <li' + (if @myTurn.step is 1 then ' class="active"' else '') + '>Card turn in</li>
                            <li' + (if @myTurn.step is 2 then ' class="active"' else '') + '>Reinforcements</li>
                            <li' + (if 3 <= @myTurn.step <= 4 then ' class="active"' else '') + '>Attack</li>
                            <li' + (if @myTurn.step is 5 then ' class="active"' else '') + '>Fortification</li>
                        </ul>
                        <div id="turn-back">' + back + '</div>
                        <div id="turn-next">' + next + '</div>
                    </div>
                    <div id="turn-current">
                        <span id="turn-description">' + content + '</span>
                        <div id="turn-actions">' + actions + '</div>
                    </div>
                </div>
            </div>')

    removeStepBanner: () ->
        $('#step-banner')?.remove()

    showDice: (rolls1, color1, rolls2, color2) ->
        # Remove the old dice
        @removeDice()

        container = $('#modal-container')

        str = '<div id="dice-results" class="dice-results">'
        for r in rolls1
            str += '<span class="die die-' + color1 + ' ' + (if r > 99 then 'wide' else '') + '">' + r + '</span>'
        for r in rolls2
            str += '<span class="die die-' + color2 + ' ' + (if r > 99 then 'wide' else '') + '">' + r + '</span>'
        str += '</div>'

        container.append(str)

    removeDice: () ->
        $('#dice-results')?.remove()

    spawnTroopPopup: (terrID, amnt) ->
        if amnt is 0
            return

        colorClass = if amnt > 0 then 'positive' else 'negative'

        container = $('#modal-container')

        popup = $('<div class="troop-popup ' + colorClass + '">' + Math.abs(amnt) + '</div>')
        container.append(popup)

        terr = $("#territory-#{terrID}")

        popup.offset({
            top: terr.offset().top + .5 * terr.height() - 0.5 * popup.height()
            left: terr.offset().left + .5 * terr.width() - 0.5 * popup.width()
        })
        popup.css('transform', 'translate(0, -50px)').fadeOut(1000, () -> $(this).remove())

    showPlaceTroopsUI: (terrID) ->
        if (self.troopsPopup?)
            self.troopsPopup.close()
            self.troopsPopup = undefined

        self.troopsPopup = D12App.showTroopsMoveUI(
            {'numTroops': self.gameState.players[self.me.player_id].pending_reinforcements}, # ReinforcementsInfo
            self.createTerritoryInfoFromID(terrID), # TerritoryInfo
            (numTroops) -> # onSubmit
                self.troopsPopup = undefined
                self.placeTroops(numTroops)
            () -> # onCancel
                self.troopsPopup = undefined
                self.initializeTurn()
            )

    showAttackUI: (terrFromID, terrToID) ->
        if (self.troopsPopup?)
            self.troopsPopup.close()
            self.troopsPopup = undefined

        self.troopsPopup = D12App.showAttackUI(
            self.createTerritoryInfoFromID(terrFromID), # TerritoryInfo
            self.createTerritoryInfoFromID(terrToID), # TerritoryInfo
            (numAttacks) -> # onSendAttack
                self.ajax('attack', {
                    'territory_from': terrFromID,
                    'territory_to': terrToID,
                    'num_attacks': numAttacks,
                }, null).then((result) ->
                    if result.success is true
                        oldFromTroops = self.gameState.territories[terrFromID].troops
                        oldToPlayerId = self.gameState.territories[terrToID].player_id
                        oldToTroops = self.gameState.territories[terrToID].troops

                        self.runUpdates(result)

                        newFromTroops = self.gameState.territories[terrFromID].troops
                        newToPlayerId = self.gameState.territories[terrToID].player_id
                        if (oldToPlayerId isnt newToPlayerId)
                            newToTroops = 0
                        else
                            newToTroops = self.gameState.territories[terrToID].troops

                        canNoLongerAttack = newFromTroops is 1
                        if (self.status isnt 3)
                            self.updateTurn(result.turn, canNoLongerAttack)

                        return {
                            'fromTroopsKilled': oldFromTroops - newFromTroops,
                            'toTroopsKilled': oldToTroops - newToTroops,
                        }
                    else
                        self.reportError(result.error)
                        self.initializeTurn()
                        return {}
                )
            () -> # onCancel
                self.troopsPopup = undefined
                self.initializeTurn()
            )

    showMoveTroopsUI: (terrFromID, terrToID) ->
        onSubmit = (numTroops) ->
            self.ajax('move-troops', {
                'num_troops': numTroops,
                'expected_terr_from': terrFromID,
                'expected_terr_to': terrToID,
            }, (result) ->
                if result.success is true
                    self.runUpdates(result)
                    self.updateTurn(result.turn, true)
                else
                    self.reportError(result.error)
                    self.initializeTurn()
            )
            self.makeBannerLoading()
            self.troopsPopup = undefined

        if (self.troopsPopup?)
            self.troopsPopup.close()
            self.troopsPopup = undefined

        self.troopsPopup = D12App.showTroopsMoveUI(
            self.createTerritoryInfoFromID(terrFromID), # TerritoryInfo
            self.createTerritoryInfoFromID(terrToID), # TerritoryInfo
            onSubmit,
            () -> return # onCancel
            false, # canClose
            false # moveAtLeastOne
        )

    showFortificationUI: (terrFromID, terrToID) ->
        if (self.troopsPopup?)
            self.troopsPopup.close()
            self.troopsPopup = undefined

        self.troopsPopup = D12App.showTroopsMoveUI(
            self.createTerritoryInfoFromID(terrFromID), # TerritoryInfo
            self.createTerritoryInfoFromID(terrToID), # TerritoryInfo
            (numTroops) -> # onSubmit
                self.troopsPopup = undefined
                self.fortify(numTroops)
            () -> # onCancel
                self.troopsPopup = undefined
                self.initializeTurn()
            )

    createTerritoryInfoFromID: (terrID) ->
        territory = self.gameState.territories[terrID]
        domTerritory = $("#territory-#{terrID}")
        player = self.players[territory.player_id]

        return {
            'territory': {
                'x': parseInt(domTerritory.data('x'), 10),
                'y': parseInt(domTerritory.data('y'), 10),
                'id': terrID,
                'name': domTerritory.data('name'),
            },
            'playerColor': if player then player.color else 0,
            'numTroops': territory.troops,
        }

    # Partials
    setBannerDescription: (content) ->
        $('#turn-description').html(content)

    setBannerActions: (actions) ->
        $('#turn-actions').html(actions)

    clearBannerActions: () -> @setBannerActions('')

    makeBannerLoading: () ->
        @setBannerActions(@ajaxLoader)
        $('#turn-next button, #turn-back button').attr('disabled', 'disabled')

    #
    # Turn flow
    #
    beginTurn: () ->
        @makeModelLoading()
        @ajax('begin-turn', {}, (result) =>
            if (result.success)
                @removeModal()
                @runUpdates(result)
                @updateTurn(result.turn)
            else
                @reportError(result.error)
                @initializeTurn()
        )

    advancePhase: (fromStep) ->
        @changePhase('advance-phase', fromStep)

    undo: (fromStep) ->
        @changePhase('undo-advance-phase', fromStep)

    changePhase: (operation, fromStep) ->
        @removeModal()
        @ajax(operation, { 'from_step': fromStep }, (result) =>
            if (result.success)
                @removeModal()
                @runUpdates(result)
                @updateTurn(result.turn)
            else
                @reportError(result.error)
                @initializeTurn()
        )
        @makeBannerLoading()

    endTurn: () ->
        @ajax('end-turn', { expected_id: @myTurn.turn_id }, (result) =>
            @runUpdates(result)
            @updateTurn(result.turn, true)
        )
        @makeBannerLoading()

    validateCards: () ->
        cards = self.getSelectedCards()
        wrap = { }
        if (not self.checkSelectedCards(cards, wrap))
            $('#card-turn-in-submit').attr('disabled', 'disabled')
        else
            $('#card-turn-in-submit').removeAttr('disabled')

    turnInCards: () ->
        cards = self.getSelectedCards()
        wrap = { }
        if (not self.checkSelectedCards(cards, wrap))
            @reportError(wrap.error)
            return false

        @ajax('turn-in-cards', {
            'cards': cards
        }, (result) =>
            if (result.success is true)
                @removeModal()
                @runUpdates(result)
                @updateTurn(result.turn, true)
            else
                @reportError(result.error)
                @initializeTurn()
        )
        @makeModelLoading()

        return false

    placeTroopsFromSelectBox: () ->
        self.placeTroops($('#troops-select').val())

    placeTroops: (numTroops) ->
        @ajax('place-troops', {
            'territory': @selectedTerritory,
            'num_troops': numTroops,
        }, (result) =>
            if result.success is true
                @runUpdates(result)
                @clearSelections()
                @updateTurn(result.turn, true)
            else
                @reportError(result.error)
                @initializeTurn()
        )
        @makeBannerLoading()

    sendAttack: () ->
        @attacksQueued++

        if @attackRequestActive
            return

        @attackRequestActive = true
        numAttacks = @attacksQueued
        @attacksQueued = 0

        @ajax('attack', {
            'territory_from': @selectedTerritory,
            'territory_to': @targetedTerritory,
            'num_attacks': numAttacks,
        }, (result) =>
            @attackRequestActive = false
            if @attacksQueued > 0
                @attacksQueued-- # To undo the extra ++ that comes with calling this method
                @sendAttack()

            if result.success is true
                @runUpdates(result)
                if @status isnt 3
                    # Force reset if we no longer have enough troops to attack.
                    @updateTurn(result.turn, @gameState.territories[@selectedTerritory].troops is 1)
            else
                @reportError(result.error)
                @initializeTurn()
        )

    moveTroops: () ->
        @ajax('move-troops', {
            'num_troops': $('#troops-select').val(),
        }, (result) =>
            if result.success is true
                @runUpdates(result)
                @updateTurn(result.turn, true)
            else
                @reportError(result.error)
                @initializeTurn()
        )
        @makeBannerLoading()

    fortifyFromSelectBox: () ->
        self.fortify($('#troops-select').val())

    fortify: (numTroops) ->
        @ajax('fortify', {
            'territory_from': @selectedTerritory,
            'territory_to': @targetedTerritory,
            'num_troops': numTroops,
        }, (result) =>
            if (result.success is true)
                @runUpdates(result)
                @updateTurn(result.turn, true)
            else
                @reportError(result.error)
                @initializeTurn()
        )
        @makeBannerLoading()

    #
    # Territory selection
    #
    clearSelections: () ->
        @clearSelect()
        @clearTarget()

    clearSelect: () ->
        $("#territory-#{@selectedTerritory}")?.parent().removeClass('selected')
        @selectedTerritory = null

        if (@troopsPopup?)
            @troopsPopup.close()
            @troopsPopup = undefined

    clearTarget: () ->
        $("#territory-#{@targetedTerritory}")?.parent().removeClass('target')
        @targetedTerritory = null

        if (@troopsPopup?)
            @troopsPopup.close()
            @troopsPopup = undefined

    selectTerritory: (terrID, elmt) ->
        if @attacksQueued > 0 or terrID is @selectedTerritory
            return

        @clearSelect()

        elmt.parent().addClass('selected')
        @selectedTerritory = terrID

        @afterSelect()

    targetTerritory: (terrID, elmt) ->
        if @attacksQueued > 0 or terrID is @selectedTerritory or terrID is @targetedTerritory
            return

        @clearTarget()

        elmt.parent().addClass('target')
        @targetedTerritory = terrID

        @afterTarget()

    afterSelect: ->
        switch @myTurn.step
            when 2
                @setBannerDescription('Choose how many troops you want to place.')
                @showPlaceTroopsUI(@selectedTerritory)
            when 3
                # If we switch the attack from country and the target territory is not adjacent.
                # Just reset it.
                if @targetedTerritory? and not @areTerritoriesAdjacent(@selectedTerritory, @targetedTerritory)
                    self.clearTarget()

                if @targetedTerritory?
                    @afterTarget()
                else
                    @setBannerDescription('Choose a territory to attack.')
            when 5
                @clearTarget()
                if @troopsPopup?
                    @troopsPopup.close()
                    @troopsPopup = undefined
                @setBannerDescription('Choose a territory to fortify to.')
                @setBannerActions('<button onclick="playGame.initializeTurn()">Clear selection</button>')

    afterTarget: ->
        switch @myTurn.step
            when 3
                @setBannerDescription('Attacking...')
                @showAttackUI(@selectedTerritory, @targetedTerritory)
            when 5
                @setBannerDescription('Choose how many troops you want to move.')
                @showFortificationUI(@selectedTerritory, @targetedTerritory)

    #
    # Helpers
    #
    isTerritoryMine: (terrID) ->
        return self.gameState.territories[terrID].player_id is self.me.player_id

    isTerritoryFriendly: (terrID) ->
        return self.gameState.territories[terrID].player_id isnt 0 and
            (self.players[self.gameState.territories[terrID].player_id].team is self.me.team)

    isTerritorySurrounded: (terrID) -> @checkAllAdjacentForCondition(terrID, @isTerritoryMine)

    isTerritoryIsolated: (terrID) -> @checkAllAdjacentForCondition(terrID,
        (tID) -> not self.isTerritoryFriendly(tID))

    checkFortificationConnectivity: (fromID, toID) ->
        if @fortification is 1
            return @areTerritoriesAdjacent(fromID, toID)
        else if @fortification >= 2
            return @areTerritoriesConnected(fromID, toID, @me.team)

    getAdjacentTerritories: (terrID) -> $("#territory-#{terrID}").attr('data-adjacencies').split(',')

    checkAllAdjacentForCondition: (terrID, checkFunc) -> @getAdjacentTerritories(terrID).every(checkFunc)

    areTerritoriesAdjacent: (fromID, toID) ->
        fromID = parseInt(fromID, 10)
        toID = parseInt(toID, 10)

        adj = @getAdjacentTerritories(fromID)
        for t in adj
            t = parseInt(t, 10)
            if t is toID
                return true

        return false

    areTerritoriesConnected: (fromID, toID, team) ->
        fromID = parseInt(fromID, 10)
        toID = parseInt(toID, 10)
        team = parseInt(team, 10)

        if fromID is toID
            return true

        hs = { fromID: true }
        q = [ fromID ]

        until q.length is 0
            c = q.shift()
            adj = @getAdjacentTerritories(c)
            for t in adj
                t = parseInt(t, 10)
                pID = self.gameState.territories[t].player_id
                if (pID > 0 and self.players[pID].team is team)
                    if t is toID
                        return true
                    if not hs[t]
                        q.push(t)
                        hs[t] = true

        return false

    getSelectedCards: () ->
        checked = $('[data-card-checkbox]:checked')
        cards = []
        checked.each((i, c) ->
            cards.push(parseInt($(c).attr('data-card-checkbox'), 10))
        )
        return cards

    checkSelectedCards: (cards, wrap) ->
        if (cards.length isnt 3)
            wrap.error = 'You have to select exactly three cards.'
            return false

        cardInfo = []
        for i, c of cards
            info = self.cards.filter((c2) -> (c >> 2) is c2.territory_id)[0]
            if not info?
                wrap.error = 'You can only turn in cards you own.'
                return false
            cardInfo.push(info)

        ofColor = []
        # Three of same color
        for i in [1, 2, 3]
            if cardInfo.every((c) -> c.color is i or c.color is 0)
                return true
            if cardInfo.some((c) -> c.color is i)
                ofColor[i] = true

        # Three of different color
        numWilds = cardInfo.filter((c) -> c.color is 0).length

        if ofColor.length + numWilds >= 3
            return true

        wrap.error = 'This is not a valid set.'
        return false
